// Module Đề Nghị Tạo HĐ (Sprint 3 MVP) — Phase 1.
// BE: docs/features/be-023-025-contract-request-flow.md

const ContractRequest = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "contract-request" */ '@/view/pages/contract-request/index.vue'
  );
const ContractRequestList = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "contract-request-list" */ '@/view/pages/contract-request/List.vue'
  );
const ContractRequestUpsert = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "contract-request-upsert" */ '@/view/pages/contract-request/Upsert.vue'
  );

export default [
  {
    path: '/contract-requests',
    component: ContractRequest,
    children: [
      {
        path: '/',
        name: 'list-contract-request',
        component: ContractRequestList,
        meta: {
          title: 'Đề nghị tạo HĐ - VF',
        },
      },
      {
        path: 'create',
        name: 'create-contract-request',
        component: ContractRequestUpsert,
        meta: {
          title: 'Tạo Đề nghị HĐ - VF',
        },
      },
      {
        path: ':id/edit',
        name: 'edit-contract-request',
        component: ContractRequestUpsert,
        meta: {
          title: 'Sửa Đề nghị HĐ - VF',
        },
        props: true,
      },
    ],
  },
];
